import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavController, LoadingController, IonContent, MenuController } from '@ionic/angular';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';

import { EventSeriesInfo } from '../../models/event-series-info';
import { PublicEventInfo } from '../../models/public-event-info';
import { Constants } from '../../models/constants';

import { EventService } from '../../services/event-service';
import { Alert } from '../../services/alert';
import { Util } from '../../services/util';
import { DeviceService } from '../../services/device-service';
import { MetaTagService } from '../../services/meta-tag-service';
import { ObservableService } from 'src/app/services/observable-service';

@Component({
  selector: 'app-event-series',
  templateUrl: './event-series.page.html',
  styleUrls: ['./event-series.page.scss'],
})
export class EventSeriesPage implements OnInit {

  eventSeriesArray: EventSeriesInfo[]

  headerSepOpacity = 0
  headerSepOpaquenessStartPx = 0;
  headerSepOpaquenessEndPx = 10;

  mobileEventCode: string
  slackUrl = ''

  constructor(
    public navCtrl: NavController,
    private eventService: EventService,
    private alert: Alert,
    private loadingCtrl: LoadingController,
    private router: Router,
    private route: ActivatedRoute,
    private changeRef: ChangeDetectorRef,
    private observables: ObservableService,
    public deviceService: DeviceService,
    private menuCtrl: MenuController,
    private metaTagService: MetaTagService
  ) {}

  ngOnInit() {

    this.menuCtrl.enable(true);

    this.mobileEventCode = this.route.snapshot.paramMap.get('mobileEventCode').toUpperCase()

    if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state) {
      // We came from nav push. Load in initial props.
      const { state: navState } = this.router.getCurrentNavigation().extras
      if (navState) {
        this.eventSeriesArray = navState.eventSeries

        this.updatePageTitle()

        if (!this.eventSeriesArray) {
          this.pullEventSeries()
        }
      }
    } else {
      this.pullEventSeries()
    }

    const redirectUri = Constants.DEV_MODE ? Constants.DEV_SLACK_REDIRECT_URI : 'https://app.getshortcut.co/setup-slack'
    this.slackUrl = `https://slack.com/oauth/authorize?scope=incoming-webhook&client_id=13329309285.894738830231&redirect_uri=${redirectUri}&state=${this.mobileEventCode}`
  }

  ionViewWillEnter() {
  }

  ionViewDidEnter() {
    this.observables.publishSetCurrentMenuRoot('/events')
  }

  private updatePageTitle() {
    if (!this.eventSeriesArray || !this.eventSeriesArray.length) return
    this.metaTagService.updateTitle(`${this.eventSeriesArray[0].name}`)
  }

  pullEventSeries() {

    let code = this.mobileEventCode.toUpperCase()

    this.eventService.submitMobileEventCode(code, (eventSeriesArray: EventSeriesInfo[]) => {

      this.eventSeriesArray = eventSeriesArray

      if (eventSeriesArray.length == 0) {
        this.alert.show('Invalid code', 'No upcoming events, or signup is not yet available.');
        return
      } else if (eventSeriesArray.length == 1) {
        this.selectEvent(eventSeriesArray[0].id)
        return
      }

      this.changeRef.detectChanges()

      this.updatePageTitle()

    }, (errorMsg: string) => {
      this.alert.show('Error Finding Events', errorMsg);
    });

  }




  // User actions

  async selectEvent(eventID: string) {

    let loading = await this.loadingCtrl.create()
    loading.present()

    this.eventService.pullPublicEventInfo(eventID, (eventInfo: PublicEventInfo) => {

      loading.dismiss()
      let navigationExtras = {
        state: {
          publicEventInfo: eventInfo,
        }
      }
      this.navCtrl.navigateForward(`/event-details/${eventID}`, navigationExtras)

    }, (errorMsg: string) => {
      loading.dismiss()

      if (!Util.isNavigationError(errorMsg)) {
        this.alert.show("Error", errorMsg);
      }

    });
  }





  // HELPERS



  firstEventType() {
    if (!this.eventSeriesArray) return ''

    if (Util.contains(this.eventSeriesArray[0].serviceCategories, 'Hair')) {
      return 'Hair'
    }
    if (Util.contains(this.eventSeriesArray[0].serviceCategories, 'Massage')) {
      return 'Massage'
    }
    if (Util.contains(this.eventSeriesArray[0].serviceCategories, 'Nails')) {
      return 'Nails'
    }

    return 'Hair';
  }

  adjustedDate(d: Date, timezoneOffset: number) {
    return Util.getDateAdjustedForOffset(d, timezoneOffset)
  }

  prettyAdjustedDate(d: Date, timezoneOffset: number) {
    let timezone = {
      offset: timezoneOffset,
    }
    return Util.dayMonthDate(d, timezone)
  }

}
